import cx from 'classnames'
import { useContext } from 'react'

import { getLinkPageUrl } from '@lib/routes'
import { StringsContext } from '@lib/strings-context'

import ButtonLink from '@components/buttons/button-link'

interface ProductActionsGuestProps {
  returnTo?: string
  className?: string
}

const ProductActionsGuest = ({
  returnTo,
  className,
}: ProductActionsGuestProps) => {
  const strings = useContext(StringsContext)

  const signupPageUrl = getLinkPageUrl({
    pageType: 'signupPage',
  })
  const loginPageUrl = getLinkPageUrl({
    pageType: 'loginPage',
    parameters: {
      return_to: returnTo,
    },
  })

  return (
    <div className={cx('p-8 bg-[#eeeeee] rounded-md', className)}>
      <p className="font-medium text-base">{strings.productNotLoggedIn}</p>

      <div className="mt-4">
        <ButtonLink href={signupPageUrl} variant="filled">
          {strings.buttonSignup}
        </ButtonLink>
        <ButtonLink href={loginPageUrl} variant="outlined" className="ml-4">
          {strings.buttonLogin}
        </ButtonLink>
      </div>
    </div>
  )
}

export default ProductActionsGuest
